// test218
(218 && 0);
